import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { OPERATORS } from '../../odata-filter/models/operators';
import { SearchValueType } from '../../odata-filter/models/search-value-type';
import {
  FilterUIType,
  ODataFilter,
  ODataFilterValues
} from '../../odata-filter/models/odata-filter';
import {
  MultiselectEvent,
  MultiselectItem
} from '../../../../../shared-app-portal/components/multiselect/multiselect.component';
import { FilterOperatorType } from '../../odata-filter/models/filter-operator-type';
import { AutomationConditionItem, SelectedCondition } from '../automation-condition.model';

@Component({
  selector: 'app-automation-condition-builder-item',
  templateUrl: './automation-condition-builder-item.component.html',
  styleUrls: ['./automation-condition-builder-item.component.scss'],
  standalone: false
})
export class AutomationConditionBuilderItemComponent implements OnInit {
  @Input() selectedCondition: SelectedCondition;
  @Input() availableConditions: AutomationConditionItem[];
  @Input() index: number = 0;
  @Input() hideAddRemove: boolean;
  @Input() isSubCondition: boolean = false;
  /** Connector word before each condition after the first ('And' default; 'Or' for OR filters). */
  @Input() conjunction: 'And' | 'Or' = 'And';
  @HostBinding('class.warning') showWarning = false;

  @Output() delete = new EventEmitter();
  @Output() addSubCondition = new EventEmitter();
  myControl = new UntypedFormControl();
  multiselectItems: MultiselectItem[];
  get operators() {
    return OPERATORS[this.selectedCondition.filter.valueType].operators;
  }

  get showAddSubConditionButton(): boolean {
    return (
      this.selectedCondition &&
      this.selectedCondition.filterOperator &&
      this.selectedCondition.uiType == FilterUIType.Multiselect &&
      this.selectedCondition.filterOperator.displayOperator != FilterOperatorType.isEmpty &&
      this.selectedCondition.hasSubFilter &&
      !this.selectedCondition.isSubFilterAdded
    );
  }

  constructor() {}

  ngOnInit(): void {
    if (this.selectedCondition.showFieldDeletedWarning) {
      this.showWarning = true;
    }
    if (this.selectedCondition.filter) {
      this.myControl.setValue(this.selectedCondition.filter);
      this.multiselectItems = this.selectedCondition.filter.values?.map(
        (v) => new MultiselectItem(v.searchValue, v.name)
      );
    }
  }

  get inputType() {
    switch (this.selectedCondition.filter.valueType) {
      case SearchValueType.Number:
        return 'number';
      case SearchValueType.Date:
      case SearchValueType.DateRange:
        return 'date';
      default:
        return 'text';
    }
  }
  get uiType() {
    return FilterUIType;
  }

  get selectedMultiselectItems(): MultiselectItem[] {
    return this.selectedCondition.searchValues.map(
      (v) => new MultiselectItem(v.searchValue, v.name)
    );
  }

  get textBoxPlaceholder(): string {
    return this.selectedCondition.uiType == FilterUIType.Textbox &&
      this.selectedCondition.filterOperator.actualOperator == FilterOperatorType.in
      ? `Use ';' to separate emails...`
      : 'Search here...';
  }

  displayFn(filter: ODataFilter): string {
    return filter && filter.displayName ? filter.displayName : '';
  }

  onDelete() {
    this.delete.emit();
  }

  multiselectSelectionChanged(event: MultiselectEvent) {
    this.selectedCondition.isFilterApplied = false;
    this.selectedCondition.searchValues = event.selectedItems.map(
      (x) => new ODataFilterValues(x.id, x.name)
    );
  }

  autocompleteSelectedChanged(filter) {
    this.selectedCondition.filter = filter;
    this.selectedCondition.filterOperator = this.operators[0];
    this.selectedCondition.isFilterApplied = false;
    this.multiselectItems = this.selectedCondition.filter.values?.map(
      (v) => new MultiselectItem(v.searchValue, v.name)
    );
    this.resetSelectedConditionSearchValues();
  }

  resetSelectedConditionSearchValues() {
    this.selectedCondition.searchValue = '';
    this.selectedCondition.searchValues = [];
  }

  onOperatorsSelectionChange() {
    this.selectedCondition.isFilterApplied = false;
    if (
      !this.selectedCondition.filterOperator ||
      this.selectedCondition.filterOperator.displayOperator == FilterOperatorType.isEmpty
    ) {
      this.selectedCondition.selectedSubConditions = [];
    }
  }
}
